var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('VHeaderIndividualItem'),_c('div',{staticClass:"row",attrs:{"id":"print-content"}},[_c('div',{staticClass:"col-12"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }